import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import ContentSection from "sections/landingPage/ContentSection";

import styles from "./styles";

const InfoMission = () => {
  return (
    <Box position="relative">
      <ContentSection gridContainerProps={{ spacing: 6, alignItems: "start" }}>
        <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
          <Typography component="h2" variant="h1" align="center">
            Mission
          </Typography>
          <Box sx={styles.image}></Box>
          <Typography paragraph align="center">
            Uniqly's mission is to redefine how people interact with physical
            products by merging them with dynamic digital experiences. We
            empower brands, creators, and artists to elevate their fashion and
            lifestyle items with interactive storytelling, smart tags, and
            real-time engagement — creating a new standard for product-driven
            e-commerce.
            <br /> <br /> As a team, we believe that the future of retail lies
            in connecting the physical and digital worlds. By adding an
            intelligent layer to everyday products, we help brands unlock new
            marketing potential, deepen customer relationships, and lead the
            next wave of experiential commerce.
          </Typography>
        </Box>
        <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
          <Typography component="h2" variant="h1" align="center">
            Vision
          </Typography>
          <Box sx={styles.image}></Box>
          <Typography paragraph align="center">
            We envision a world where every physical product has a smart digital
            layer — providing instant access to content, history, and
            interactive experiences. By adding this invisible layer of
            intelligence to everyday items, we unlock new ways for brands to
            connect with users, build trust, and extend product value across
            both physical and digital spaces.
          </Typography>
        </Box>
      </ContentSection>
    </Box>
  );
};

export default InfoMission;
